import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ClassToggleService, HeaderComponent } from '@coreui/angular';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { remove } from 'src/app/store/roles';
import { UserIdleService } from 'angular-user-idle';

@Component({
  selector: 'app-default-header',
  templateUrl: './default-header.component.html',
})
export class DefaultHeaderComponent extends HeaderComponent {

  @Input() sidebarId: string = "sidebar";

  public newMessages = new Array(4)
  public newTasks = new Array(5)
  public newNotifications = new Array(5)

  loader: boolean = true

  isModal: boolean = false

  sesCloseTime: number = 30

  constructor(
    private classToggler: ClassToggleService,
    private cookieService: CookieService,
    private router: Router,
    private toastr: ToastrService,
    private store: Store,
    private userIdle: UserIdleService
  ) {
    super();
  }

  ngOnInit() {
    this.watchIdle()
  }

  ngAfterViewInit() {
    this.loader = false
  }

  logOut() {
    document.cookie = 'admin_token' + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    this.store.dispatch(remove());
    this.router.navigateByUrl('/login')
    this.toastr.success('Logout Successfully')
  }

  watchIdle() {
    this.userIdle.startWatching(); //Start watching for user inactivity.

    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => console.log(count, 'count'));

    // this.isModal = true
    // this.sesCloseTime = this.sesCloseTime - 1
    this.userIdle.onTimeout().subscribe(() => this.logOutBySes()); // Start watch when time is up.
  }

  // restartSes() {
  //   this.userIdle.resetTimer()
  //   this.sesCloseTime = 30
  //   this.isModal = false
  // }

  logOutBySes() {
    this.userIdle.stopTimer();
    this.userIdle.stopWatching();

    document.cookie = 'admin_token' + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    this.store.dispatch(remove());
    this.router.navigateByUrl('/login')
    this.toastr.success('Your session has expired.')
  }

}
